import React, { useState } from 'react';
import { createInquiry } from '../../api/inquiriesApi';
import '../../styles/inquiry.css';

export const CATEGORIES = ['ログインできない', 'パスワードを忘れた', 'POS連携について', '不具合の報告', 'その他'];
export const MAX_BODY = 2000;
// 2026-10-26 より前の送信は、サーバーに届いていなかった（鬼塚さんの依頼で、再送信をお願いする）
const RESEND_NOTE = '※2026年10月26日以前にお送りいただいた場合は、誠に恐れ入りますが再送信いただけますと幸いです。';

/**
 * お問い合わせの入力（カテゴリを選ぶ → 内容を書く → 送信）。
 * 送れたら onSent(結果: {id, numberLabel, ...}) を呼ぶ。失敗したら、理由を出して、入力は残す（もう一度送れる）。
 */
export default function InquiryForm({ onSent }) {
  const [cat, setCat] = useState('');
  const [msg, setMsg] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const valid = cat && msg.trim().length > 0 && !sending;

  const submit = async () => {
    setSending(true);
    setError('');
    try {
      const res = await createInquiry({ category: cat, body: msg.trim() });
      onSent?.(res);
    } catch (err) {
      setError(err.message || '送信に失敗しました。時間をおいて、もう一度お試しください');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="help-form">
      <div className="help-form-label">カテゴリ</div>
      <div className="help-cats" role="group" aria-label="カテゴリ">
        {CATEGORIES.map((c) => (
          <button
            key={c}
            type="button"
            className={`help-cat${cat === c ? ' is-on' : ''}`}
            aria-pressed={cat === c}
            onClick={() => setCat(c)}
          >
            {c}
          </button>
        ))}
      </div>
      <div className="help-form-label">内容</div>
      <textarea
        className="help-textarea"
        placeholder="お困りの内容を、できるだけ詳しくお書きください"
        value={msg}
        onChange={(e) => setMsg(e.target.value)}
        rows={6}
        maxLength={MAX_BODY}
        aria-label="お問い合わせ内容"
      />
      <div className="help-count" aria-hidden="true">
        {msg.length} / {MAX_BODY}
      </div>
      {error && (
        <div className="help-error" role="alert">
          {error}
        </div>
      )}
      <button type="button" className="onb-cta onb-cta--full" disabled={!valid} onClick={submit}>
        {sending ? '送信中…' : '送信する'}
      </button>
      <p className="help-note">{RESEND_NOTE}</p>
    </div>
  );
}
